// item 50 — deposit/final invoices generated from a proposal's work order are named
// off the proposal. This was duplicated verbatim in the approval + completion wizards;
// centralised here so the two halves of the 50/50 split can never drift apart.

interface NameableProposal {
  proposalTitle?: string | null;
  proposalNumber: string;
}

// the human-facing name for a proposal: its title, else its number.
export const friendlyProposalName = (p: NameableProposal): string => (
  p.proposalTitle?.trim() || p.proposalNumber
);

export const depositInvoiceName = (p: NameableProposal): string => `${friendlyProposalName(p)} - Deposit`;
export const finalInvoiceName = (p: NameableProposal): string => `${friendlyProposalName(p)} - Final`;

// dart (2026-07-15, Chad) — versioned duplicate/export naming: "X" → "X V.1" → "X V.2" … instead of
// "COPY of COPY of X". Used for the Duplicate action and the Export-standard-proposal button.

// strip a trailing " V.N" so re-duplicating a version keeps ONE clean root (no "X V.1 V.1").
export const versionRoot = (title: string): string => {
  const t = (title ?? '').trim();
  const m = t.match(/^(.*)\sV\.\d+$/);
  return m ? m[1].trim() : t;
};

// the next version name for `base` given the titles that already exist (siblings sharing the root).
// First duplicate of "X" → "X V.1"; with "X V.1" present → "X V.2". String-based (no regex on the
// user's title, which may contain regex metacharacters).
export const nextVersionName = (base: string, existingTitles: string[]): string => {
  const root = versionRoot(base);
  const prefix = `${root} V.`;
  let max = 0;
  (existingTitles ?? []).forEach((raw) => {
    const t = (raw ?? '').trim();
    if (t.startsWith(prefix)) {
      const n = parseInt(t.slice(prefix.length), 10);
      if (!Number.isNaN(n)) max = Math.max(max, n);
    }
  });
  return `${root} V.${max + 1}`;
};
